import {
    InterruptionByUserModel,
    SchedulingByDataModel,
    WorkshiftSchedulingByUserModel,
} from '../../../../../models/requests-management/workshift&Interruption';
import { DataInfo } from '../../modals/DetailsModal';
import './index.css';

export interface SchedulingCardProps {
    day: number;
    year: number;
    month: number;
    workshiftScheduling: SchedulingByDataModel | undefined;
    setDetailsInfo: (newData: any) => void;
    setIsOpenDetails: (newData: boolean) => void;
}

export const SchedulingCard = ({
    day,
    month,
    year,
    workshiftScheduling,
    setDetailsInfo,
    setIsOpenDetails,
}: SchedulingCardProps) => {
    const getFormattedDate = () => {
        const date = new Date(year, month, day);

        const dayOfWeek = date.toLocaleString('es-ES', { weekday: 'long' });
        const dateOfMonth = date.getDate();
        const yearNumber = date.getFullYear();

        return `${dayOfWeek} ${dateOfMonth} ${yearNumber}`;
    };
    const handlerDetails = (
        className: string,
        interruption: InterruptionByUserModel | undefined,
        scheduling: WorkshiftSchedulingByUserModel | undefined
    ) => {
        if (interruption || scheduling) {
            let newEvent: DataInfo = {} as DataInfo;
            if (interruption) {
                newEvent = {
                    className: className,
                    title: interruption?.interruptionName ?? '',
                    extendedProps: {
                        documentNumber: interruption?.documentNumber,
                        employee: interruption?.fullName,
                        date: interruption?.date,
                        endTime: interruption?.endTime,
                        startTime: interruption?.startTime,
                        endTime2: '',
                        startTime2: '',
                        observations: interruption?.observations,
                        isDuplex: false,
                        isExceptional: false,
                        isNextDay: false,
                        workshiftName: '',
                        hasAvailability: false,
                        workshiftId: null,
                        personId: interruption.personId,
                        interruptionName: interruption?.interruptionName,
                        interruptionId: interruption.interruptionId,
                        interruptionTypeId: interruption?.interruptionTypeId,
                        isAdditionalHour: interruption?.isAdditionalHour,
                        costCenters: [],
                        operationCenters: []
                    },
                    start: interruption?.date ?? '',
                    end: interruption?.date ?? '',
                };
            } else if (scheduling) {
                newEvent = {
                    title: scheduling.workshiftName,
                    className: className,
                    extendedProps: {
                        documentNumber: scheduling?.documentNumber,
                        employee: scheduling?.fullName,
                        isDuplex: scheduling?.isDuplex,
                        isExceptional: scheduling?.isExceptional,
                        isNextDay: scheduling?.isNextDay,
                        workshiftName: scheduling?.workshiftName,
                        date: scheduling?.date,
                        startTime: scheduling.firstArrival,
                        endTime: scheduling?.isDuplex
                            ? scheduling.firstDeparture
                            : scheduling.secondDeparture,
                        startTime2: scheduling.secondArrival,
                        endTime2: scheduling.secondDeparture,
                        observations: '',
                        hasAvailability: scheduling.hasAvailability,
                        workshiftId: scheduling.workshiftId,
                        personId: scheduling.personId,
                        interruptionName: '',
                        interruptionId: null,
                        interruptionTypeId: null,
                        isAdditionalHour: null,
                        costCenters: scheduling.costCenters,
                        operationCenters: scheduling.operationCenters
                    },
                    start: scheduling?.date ?? '',
                    end: scheduling?.date ?? '',
                };
            }

            setDetailsInfo(newEvent);
            setIsOpenDetails(true);
        }
    };

    return (
        <div className={`schedulingCard  mt-2  `}>
            <div className={'schedulingCard__wrapper my-3'}>
                <div
                    onClick={() =>
                        handlerDetails(
                            'workshift',
                            undefined,
                            workshiftScheduling?.workshiftSchedulingModel
                        )
                    }
                    className={
                        workshiftScheduling?.workshiftSchedulingModel
                            ? 'workshift p-3 ' &&
                              workshiftScheduling?.workshiftSchedulingModel
                                  ?.isExceptional
                                ? ' workshift p-3 exceptional'
                                : 'workshift p-3'
                            : ' p-3'
                    }
                >
                    <div
                        className={`${
                            false ? 'd-flex justify-content-between' : ''
                        }`}
                    >
                        <h5>{getFormattedDate()}</h5>
                        {!workshiftScheduling?.workshiftSchedulingModel && (
                            <h5 className='text-muted'>Sin asignación</h5>
                        )}
                    </div>
                    {workshiftScheduling?.workshiftSchedulingModel && (
                        <div className='mt-3 '>
                            <h6 className='text-center mb-3'>
                                {
                                    workshiftScheduling?.workshiftSchedulingModel
                                        .workshiftName
                                }
                            </h6>

                            {workshiftScheduling?.workshiftSchedulingModel
                                .isDuplex ? (
                                <>
                                    <div>
                                        <div className='d-flex justify-content-between'>
                                            <p className='mb-1'>
                                                Hora Primera Entrada
                                            </p>
                                            <p className='mb-1'>
                                                {
                                                    workshiftScheduling
                                                        ?.workshiftSchedulingModel
                                                        .firstArrival
                                                }
                                            </p>
                                        </div>

                                        <div className='d-flex justify-content-between'>
                                            <p className=''>Hora Primera Salida</p>
                                            <p className=''>
                                                {
                                                    workshiftScheduling
                                                        ?.workshiftSchedulingModel
                                                        .firstDeparture
                                                }
                                            </p>
                                        </div>
                                    </div>

                                    <div>
                                        <div className='d-flex justify-content-between'>
                                            <p className='mb-1'>
                                                Hora Segunda Entrada
                                            </p>
                                            <p className='mb-1'>
                                                {
                                                    workshiftScheduling
                                                        ?.workshiftSchedulingModel
                                                        .secondArrival
                                                }
                                            </p>
                                        </div>

                                        <div className='d-flex justify-content-between'>
                                            <p className=''>Hora Segunda Salida</p>
                                            <p className=''>
                                                {
                                                    workshiftScheduling
                                                        ?.workshiftSchedulingModel
                                                        .secondDeparture
                                                }
                                            </p>
                                        </div>
                                    </div>
                                </>
                            ) : (
                                <div>
                                    <div className='d-flex justify-content-between'>
                                        <p className='mb-1'>Hora Inicio</p>
                                        <p className='mb-1'>
                                            {
                                                workshiftScheduling
                                                    ?.workshiftSchedulingModel
                                                    .firstArrival
                                            }
                                        </p>
                                    </div>

                                    <div className='d-flex justify-content-between'>
                                        <p className=''>Hora Final</p>
                                        <p className=''>
                                            {
                                                workshiftScheduling
                                                    ?.workshiftSchedulingModel
                                                    .secondDeparture
                                            }
                                        </p>
                                    </div>
                                </div>
                            )}

                            {workshiftScheduling?.workshiftSchedulingModel
                                ?.hasAvailability == true && (
                                <h6 className='fw-bold'>
                                    * Para este día se asignó Disponibilidad
                                </h6>
                            )}
                        </div>
                    )}
                </div>

                {workshiftScheduling?.interruptionsModel &&
                    workshiftScheduling?.interruptionsModel.length > 0 && (
                        <div className='interruption p-3'>
                            {workshiftScheduling?.interruptionsModel.map(
                                (interruption) => (
                                    <div
                                        onClick={() =>
                                            handlerDetails(
                                                'interruption',
                                                interruption,
                                                undefined
                                            )
                                        }
                                    >
                                        <h6 className='text-center'>
                                            {interruption?.interruptionName}
                                        </h6>

                                        <div>
                                            <div className='d-flex justify-content-between'>
                                                <p className='mb-1'>Hora Inicio</p>
                                                <p className='mb-1'>
                                                    {' '}
                                                    {interruption?.startTime}
                                                </p>
                                            </div>

                                            <div className='d-flex justify-content-between'>
                                                <p className=''>Hora Final</p>
                                                <p className=''>
                                                    {' '}
                                                    {interruption?.endTime}
                                                </p>
                                            </div>

                                            {interruption?.observations && (
                                                <div className='mt-2'>
                                                    <p className='mb-1'>
                                                        Observación
                                                    </p>

                                                    <p>
                                                        {interruption?.observations}
                                                    </p>
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                )
                            )}
                        </div>
                    )}
            </div>
        </div>
    );
};
